import React from 'react';
import nykreditIcons from '../images/icons/Nykredit_Icons.svg';

import _NJ03196 from '../images/_NJ03196.jpg';
import _NJ05504 from '../images/_NJ05504.jpg';

import _privatsikring_16660 from "../images/_privatsikring_16660.jpg";
import _NJ06086 from "../images/_NJ06086.jpg";

import _NJ06799 from "../images/_NJ06799.jpg";
import Hus_2 from "../images/Hus_2.png";

import _NJ08361 from "../images/_NJ08361.jpg";
import _privatsikring_16882_V2D from "../images/_privatsikring_16882_V2D.jpg";

import _NJ07851 from "../images/_NJ07851.jpg";
import _privatsikring_15475 from "../images/_privatsikring_15475.jpg";

import _NJ07720 from "../images/_NJ07720.jpg";
import _privatsikring_16225 from "../images/_privatsikring_16225.jpg";

export const landingpageSegments = {
    boligejergjensidige: {
        query: 'utm_campaign',
        string: 'boligejergjensidige',
        icCode: '8aa76a34fe17bfd14a7032d5f21f2efcb6552',
        intellitechId: 'a3031700-4101-4dac-b149-762b2d136a2c',
        copies: {
            firstImg: _NJ03196,
            secondImg: _NJ05504,
            heroText: {
                header: 'Forsikringsselskabet til dig, der er boligejer',
                paragraph: 'Nykredits nye forsikringspartner er Privatsikring, der er ejet af Codan. Som kunde hos Nykredit har du nu mulighed for at få en række fordele målrettet dig som boligejer, hvis du samler dine forsikringer hos Privatsikring. Sammen med Nykredit kan du få rådgivning hele vejen rundt om din økonomi og attraktive forsikringer, som tilsammen giver dig finansiel tryghed i både de gode tider – og hvis skaden sker.'
            },
            first: {
                header: 'Vi forsikrer det, der betyder noget for dig',
                paragraph: '',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Husforsikring: ',
                            
                            'Vores husforsikring giver bl.a. mulighed for at tilvælge dækning ved ferieudlejning af din bolig, og så dækker vi udhuse og garager op til 75 m2, uden at det koster ekstra.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Indboforsikring: ',

                            'Du får en verdensrejseforsikring inkluderet i vores indboforsikring, og så giver vi dig nogle af markedets bedste dækninger – fx. på elektronik.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Ulykkesforsikring: ',

                            'En ulykkesforsikring med heltidsdækning sikrer dig, hvis du skulle komme til skade, uanset om det sker i fritiden eller under arbejde.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Vi tilbyder naturligvis også forsikringer, der dækker dit fritidshus, din bil eller måske din motorcykel. Se dem alle på ',

                            <a style={{ color: '#FFB600', textDecoration: 'underline' }} key="0" href="https://www.privatsikring.dk/forsikringer" target="_blank">www.privatsikring.dk/forsikringer</a>
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Samarbejdet mellem Privatsikring og Nykredit giver dig forsikringer med gode dækninger, attraktive priser, fremragende kundeservice og specielle fordele.'
                    }             
                ]
            },
            second: {
                header: [ 'Få en ekstra ', <em key={0}>fordel</em> ,' med i købet'],
                paragraph: 'Bliver du forsikringskunde hos os, kan du vælge en boligfordel, der kan minimere din risiko for skader. De tilbydes i samarbejde med Østifterne, der bl.a. arbejder for at forebygge skader.',
                accordion: {
                    husejere: [
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Alarm`,
                            headerText: 'Tyverialarm',
                            paragraphText: 'Installation af en tyverialarm, inkl. opkobling til alarmcentral. Normalprisen for installation og oprettelse kan variere, men du får det for 0 kr. Hertil kommer månedligt abonnement på 449 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Water`,
                            headerText: 'Vandalarm',
                            paragraphText: 'Undgå vandskader. Få en intelligent vandalarm, som registrerer utætte vandrør eller løbende toiletter, før det er for sent. Normalpris 1.245 kr. Din pris: 0 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Camera`,
                            headerText: 'Udskiftning af låse og nøgler',
                            paragraphText: 'Så er det dig, der bestemmer, hvem der har nøgle til dit hjem. Normalpris 2.500 kr. Din pris: 1.200 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House_1_`,
                            headerText: 'Indeklimamåling',
                            paragraphText: 'Vil du have et sundere hjem? Få undersøgt hjemmets indeklima og få vished om alt fra luftfugtighed og CO2 til radon. Normalpris 510 kr. Din pris: 0 kr.',
                        }
                    ],
                    lejlighedsejere: [
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House_1_`,
                            headerText: 'Udskiftning af låse og nøgler',
                            paragraphText: 'Så er det dig, der bestemmer, hvem der har nøgle til dit hjem. Normalpris 2.500 kr. Din pris: 1.200 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Alarm`,
                            headerText: 'Tyverialarm',
                            paragraphText: 'Installation af en tyverialarm inkl. opkobling til alarmcentral. Normalprisen for installation og oprettelse kan variere, men du får det for 0 kr. Hertil kommer et månedligt abonnement på 409 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Fingerprint`,
                            headerText: 'DNA-mærkning',
                            paragraphText: 'Skræm indbrudstyven og øg chancen for at få stjålne værdigenstande retur med DNA-mærkning. Normalpris 795 kr. Din pris: 0 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House`,
                            headerText: 'Indeklimamåling',
                            paragraphText: 'Vil du have et sundere hjem? Få undersøgt hjemmets indeklima og få vished om alt fra luftfugtighed og CO2 til radon. Normalpris 510 kr. Din pris: 0 kr.',
                        }
                    ]
                }
            },
            third: {
                header: 'Det er nemt at være kunde hos os',
                paragraph: '',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Vi behandler de fleste skader samme dag.'
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Du kan få akut hjælp døgnet rundt.'
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Rådgivning, når det passer dig – online, telefonisk eller ved et fysisk møde.'
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Rådgivning fra professionelle assurandører.'
                    }
                ]
            }
        }
    },
    boligejer: {
        query: 'utm_campaign',
        string: 'boligejer',
        icCode: 'e1a088a99034ea2ff354366d1ffc4230b6552',
        intellitechId: 'bc35a9ce-45c4-432c-8597-d3be614948d7',
        copies: {
            firstImg: _privatsikring_16660,
            secondImg: _NJ06086,
            heroText: {
                header: 'Forsikringsselskabet til dig, der er boligejer',
                paragraph: `Nykredits nye forsikringspartner er Privatsikring, der er ejet af Codan. Som kunde hos Nykredit har du nu mulighed for at få en række fordele målrettet dig som boligejer, hvis du samler dine forsikringer hos Privatsikring. Sammen med Nykredit kan du få rådgivning hele vejen rundt om din økonomi og attraktive forsikringer, som tilsammen giver dig finansiel tryghed i både de gode tider – og hvis skaden sker.

                Du er i gode hænder hos Privatsikring 
                Vi er bankernes foretrukne samarbejdspartner og førende indenfor digital skadesbehandling. Det er bl.a. derfor vores over 100.000 kunder har givet os fremragende anmeldelser på Trustpilot.`
            },
            first: {
                get header() {return landingpageSegments.boligejergjensidige.copies.first.header},
                paragraph: '',
                get ul() {return landingpageSegments.boligejergjensidige.copies.first.ul}
            },
            second: {
                get header() {return landingpageSegments.boligejergjensidige.copies.second.header},
                get paragraph() {return landingpageSegments.boligejergjensidige.copies.second.paragraph},
                get accordion() {return landingpageSegments.boligejergjensidige.copies.second.accordion}
            },
            third: {
                get header() {return landingpageSegments.boligejergjensidige.copies.third.header},
                paragraph: '',
                get ul() {return landingpageSegments.boligejergjensidige.copies.third.ul}
            }
        }
    },

    pbgjensidige: {
        query: 'utm_campaign',
        string: 'pbgjensidige',
        icCode: '7523690f819b01574958cdbf024c357fb6552',
        intellitechId: 'e41c0a52-e51f-4596-9ab2-a1c5d4c8aee4',
        style: {
            heroContainer: {
                background: 'rgba(040, 203, 214, 1)'
            }
        },
        copies: {
            firstImg: _NJ06799,
            secondImg: Hus_2,
            heroText: {
                header: 'Dit liv. Din formue. Dine værdier. Din tryghed',
                paragraph: 'Nykredits nye forsikringspartner er Privatsikring, der er ejet af Codan. Som kunde hos Nykredit kan du med fordel flytte dine forsikringer til Privatsikring og få tilpasset dine forsikringer, så de matcher dit liv. Vi tilbyder dig en række særlige fordele og produkter, der dækker dig, dine nærmeste og dine værdier optimalt. Du får også adgang til Privatsikrings VIP-telefonnumre, så du bl.a. kan få hurtig hjælp ved skader.'
            },
            first: {
                header: 'Vi forsikrer det, der betyder noget for dig',
                paragraph: 'Vi tilbyder en række udvidede forsikringer, som kan tilpasses din bolig, dine værdier og behov.',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Husforsikring: ',

                            'Vores husforsikring giver dig fx mulighed for at vælge dækning, hvis du ferieudlejer din bolig. Og så dækker vi også udhuse og garager op til 75 m2, uden at det koster ekstra.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Indboforsikring: ',
                            'Du får en verdensrejseforsikring inkluderet i vores indboforsikring, og så giver vi dig nogle af markedets bedste dækninger på fx elektronik.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Vi dækker op til 25% mere end dine valgte erstatningssummer for enkeltgenstande, samlinger og designgenstande, samt særlige private værdigenstande. Vi tager nemlig højde for, at visse genstande stiger i værdi over årene.'
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Bilforsikring: ',

                            'Som kunde hos os får du hurtig hjælp og kompetent service, hvis uheldet er ude. Vi sikrer dig lånebil og sidder klar 24/7 med akuthjælp. Du kan også kombinere bilforsikringen med en række tilvalg.'
                        ],
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Ulykkesforsikring: ',

                            'En ulykkesforsikring med heltidsdækning sikrer dig, hvis du skulle komme til skade, uanset om det sker i fritiden eller under arbejde.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Egen virksomhed: ',

                            'Er du virksomhedsejer, kan du få én samlet rådgivning om dine private forsikringer og erhvervsforsikringer.'
                        ]
                    }
                ]
            },
            second: {
                header: [ 'Få en ekstra ', <em key={0}>fordel</em> ,' med i købet'],
                paragraph: 'Bliver du forsikringskunde hos os, kan du vælge en boligfordel, der kan minimere din risiko for skader. De tilbydes i samarbejde med Østifterne, der bl.a. arbejder for at forebygge skader.',
                accordion: {
                    husejere: [
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Alarm`,
                            headerText: 'Tyverialarm',
                            paragraphText: 'Installation af en tyverialarm, inkl. opkobling til alarmcentral. Normalprisen for installation og oprettelse kan variere, men du får det for 0 kr. Hertil kommer månedligt abonnement på 449 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Water`,
                            headerText: 'Vandalarm',
                            paragraphText: 'Undgå vandskader. Få en intelligent vandalarm, som registrerer utætte vandrør eller løbende toiletter, før det er for sent. Normalpris 1.245 kr. Din pris: 0 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Camera`,
                            headerText: 'Udskiftning af låse og nøgler',
                            paragraphText: 'Så er det dig, der bestemmer, hvem der har nøgle til dit hjem. Normalpris 2.500 kr. Din pris: 1.200 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House_1_`,
                            headerText: 'Indeklimamåling',
                            paragraphText: 'Vil du have et sundere hjem? Få undersøgt hjemmets indeklima og få vished om alt fra luftfugtighed og CO2 til radon. Normalpris 510 kr. Din pris: 0 kr.',
                        }
                    ],
                    lejlighedsejere: [
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House_1_`,
                            headerText: 'Udskiftning af låse og nøgler',
                            paragraphText: 'Så er det dig, der bestemmer, hvem der har nøgle til dit hjem. Normalpris 2.500 kr. Din pris: 1.200 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Alarm`,
                            headerText: 'Tyverialarm',
                            paragraphText: 'Installation af en tyverialarm inkl. opkobling til alarmcentral. Normalprisen for installation og oprettelse kan variere, men du får det for 0 kr. Hertil kommer et månedligt abonnement på 409 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#Fingerprint`,
                            headerText: 'DNA-mærkning',
                            paragraphText: 'Skræm indbrudstyven og øg chancen for at få stjålne værdigenstande retur med DNA-mærkning. Normalpris 795 kr. Din pris: 0 kr.',
                        },
                        {
                            props: {
                                widthIcon: "22px",
                                heightIcon: "22px",
                                marginTopHeader: "0",
                                marginLeftHeader: "47px",
                                marginLeftPMediaQueriesMedium: "47px",
                                marginLeftP: "47px"
                            },
                            backgroundImg:`${nykreditIcons}#House`,
                            headerText: 'Indeklimamåling',
                            paragraphText: 'Vil du have et sundere hjem? Få undersøgt hjemmets indeklima og få vished om alt fra luftfugtighed og CO2 til radon. Normalpris 510 kr. Din pris: 0 kr.',
                        }
                    ]
                }
            },
            third: {
                header: 'Særlige service til dig, der har ekstra meget at passe på',
                paragraph: '',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            <b key={0}>VIP-kundeservice: </b>,
                            'Med VIP-telefonnummeret kommer du lynhurtigt i kontakt med vores kompetente og engagerede rådgivere.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            <b key={0}>VIP skadeservice: </b>,
                            'VIP-telefonnummeret gør, at du kommer forrest i køen og får hjælp til skader med det samme.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            <b key={0}>Fleksibel mødeform: </b>,
                            'Du bestemmer, om vi skal mødes digitalt, på telefonen eller i din bank.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            <b key={0}>Ét forsikringsselskab til både privat og erhverv: </b>,

                            'Vi kan hjælpe dig med både private forsikringer og erhvervsforsikringer til favorable priser. Så er alt samlet ét sted.'
                        ]
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            <b key={0}>Tag din bankrådgiver med på råd: </b>,

                            'Samarbejdet med Nykredit giver dig mulighed for at tage din bankrådgiver med på råd – og med til forsikringsmødet, så vi i samarbejde kan træffe de helt rigtige beslutninger.'
                        ]
                    }
                ]
            }
        }
    },
    pb: {
        query: 'utm_campaign',
        string: 'pb',
        icCode: '1e610b175fa4db24b5325f7541d323d2b6552',
        intellitechId: 'f67cae56-64f3-4c74-8882-36f2b5fe2753',
        style: {
            heroContainer: {
                get background() {return landingpageSegments.pbgjensidige.style.heroContainer.background}
            }
        },
        copies: {
            firstImg: _NJ08361,
            secondImg: _privatsikring_16882_V2D,
            heroText: {
                header: 'Dit liv. Din formue. Dine værdier. Din tryghed',
                paragraph: `Nykredits nye forsikringspartner er Privatsikring, der er ejet af Codan. Som kunde hos Nykredit kan du med fordel flytte dine forsikringer til Privatsikring og få tilpasset dine forsikringer, så de matcher dit liv. Vi giver dig rådgivning hele vejen rundt om din økonomi og attraktive forsikringer, som tilsammen giver dig finansiel tryghed i både de gode tider – og hvis skaden sker.

                Derudover tilbyder vi dig en række særlige fordele og produkter, der dækker dig, dine nærmeste og dine værdier optimalt. Du får også adgang til Privatsikrings VIP-telefonnumre, så du bl.a. kan få hurtig hjælp ved skader.`
            },
            first: {
                get header() {return landingpageSegments.pbgjensidige.copies.first.header},
                paragraph: '',
                get ul() {return landingpageSegments.pbgjensidige.copies.first.ul}
            },
            second: {
                get header() {return landingpageSegments.pbgjensidige.copies.second.header},
                get paragraph() {return landingpageSegments.pbgjensidige.copies.second.paragraph},
                get accordion() {return landingpageSegments.pbgjensidige.copies.second.accordion}
            },
            third: {
                get header() {return landingpageSegments.pbgjensidige.copies.third.header},
                paragraph: '',
                get ul() {return landingpageSegments.pbgjensidige.copies.third.ul}
            }
        }
    },

    bankkundegjensidige: {
        query: 'utm_campaign',
        string: 'bankkundegjensidige',
        icCode: '275cb3e69a3aa005dfe07691930bd426b6552',
        intellitechId: '662d52d0-d05c-4d11-885a-cb2861dca2ef',
        copies: {
            firstImg: _NJ07851,
            secondImg: _privatsikring_15475,
            heroText: {
                header: 'Forsikringer og kundeservice i særklasse',
                paragraph: `Nykredit samarbejder med Privatsikring, der er ejet af Codan. Som kunde i Nykredit kan du med fordel flytte dine forsikringer til Privatsikring, da vi har nogle af markedets bedste forsikringer til attraktive priser. Sammen med Nykredit kan du få rådgivning hele vejen rundt om din økonomi og attraktive forsikringer, som til sammen giver dig finansiel tryghed i både de gode tider – og hvis skaden sker.

                Du er i gode hænder hos Privatsikring. Vi er bankernes foretrukne samarbejdspartner og førende inden for digital skadesbehandling. Det er bl.a. derfor vores over 100.000 kunder har givet os fremragende anmeldelser på Trustpilot.`
            },
            first: {
                header: 'Vi forsikrer det, der betyder noget for dig',
                paragraph: 'Vi har nogle af markedets bedste forsikringer, som kan tilpasses dine behov, uanset hvor du er i livet.',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Indboforsikring: ',

                            'Du får en verdensrejseforsikring inkluderet i vores indboforsikring, og så giver vi dig nogle af markedets bedste dækninger på fx elektronik.'
                        ],
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Ulykkesforsikring: ',

                            'En ulykkesforsikring med heltidsdækning sikrer dig, hvis du skulle komme til skade, uanset om det sker i fritiden eller under arbejde.'
                        ],
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: [
                            'Og mange andre: Vi tilbyder naturligvis også forsikringer, der dækker dit fritidshus, din bil eller måske din motorcykel. Se dem alle på ',

                            <a style={{ color: '#FFB600', textDecoration: 'underline' }} key="0" href="https://www.privatsikring.dk/forsikringer" target="_blank">www.privatsikring.dk/forsikringer</a>
                        ],
                    },
                ]
            },
            second: {
                header: '',
                paragraph: '',
                accordion: {
                    husejere: [],
                    lejlighedsejere: []
                }
            },
            third: {
                header: 'Det er nemt at være kunde hos os',
                paragraph: '',
                ul: [
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Vi behandler de fleste skader samme dag.',
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Du kan få akut hjælp døgnet rundt.',
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Rådgivning, når det passer dig – online, telefonisk eller ved et fysisk møde.',
                    },
                    {
                        backgroundImg: `${nykreditIcons}#Check`,
                        paragraphText: 'Rådgivning fra professionelle assurandører.',
                    },
                ]
            }
        }
    },
    bankkunde: {
        query: 'utm_campaign',
        string: 'bankkunde',
        icCode: 'a4f470d3b271dffb6e2f999473ae94e0b6552',
        intellitechId: '1281c201-42b5-41fc-a5bf-81462c386948',
        copies: {
            firstImg: _NJ07720,
            secondImg: _privatsikring_16225,
            heroText: {
                get header() {return landingpageSegments.bankkundegjensidige.copies.heroText.header},
                get paragraph() {return landingpageSegments.bankkundegjensidige.copies.heroText.paragraph}
            },
            first: {
                get header() {return landingpageSegments.bankkundegjensidige.copies.first.header},
                paragraph: '',
                get ul() {return landingpageSegments.bankkundegjensidige.copies.first.ul}
            },
            second: {
                get header() {return landingpageSegments.bankkundegjensidige.copies.second.header},
                get paragraph() {return landingpageSegments.bankkundegjensidige.copies.second.paragraph},
                get accordion() {return landingpageSegments.bankkundegjensidige.copies.second.accordion}
            },
            third: {
                get header() {return landingpageSegments.bankkundegjensidige.copies.third.header},
                paragraph: '',
                get ul() {return landingpageSegments.bankkundegjensidige.copies.third.ul}
            }
        }
    }
}